import * as React from "react";
import { forwardRef } from "react";
const SvgChevronDown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 25, height: 24, viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6.09758 9.29289C6.4881 8.90237 7.12127 8.90237 7.51179 9.29289L12.8047 14.5858L18.0976 9.29289C18.4881 8.90237 19.1213 8.90237 19.5118 9.29289C19.9023 9.68342 19.9023 10.3166 19.5118 10.7071L13.5118 16.7071C13.1213 17.0976 12.4881 17.0976 12.0976 16.7071L6.09758 10.7071C5.70706 10.3166 5.70706 9.68342 6.09758 9.29289Z" }));
const ForwardRef = forwardRef(SvgChevronDown);
export { ForwardRef as ReactComponent };
